import { render, staticRenderFns } from "./TestimonialTemplate.vue?vue&type=template&id=400c07e0&scoped=true&"
import script from "./TestimonialTemplate.vue?vue&type=script&lang=ts&"
export * from "./TestimonialTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialTemplate.vue?vue&type=style&index=0&id=400c07e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c07e0",
  null
  
)

export default component.exports